var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('A4PrintPaper',{attrs:{"paper":_vm.paperData,"questions-per-page":30}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }